import Button, { type ButtonProps } from "@/components/ui/button.tsx";
import Loader from "@/components/ui/loader.tsx";

type Props = Omit<ButtonProps, "asChild"> & { isLoading: boolean };

export default function ButtonWithLoader({ children, disabled, isLoading, ...props }: Props) {
    return (
        <Button {...props} disabled={isLoading || disabled}>
            {children}
            {isLoading && <Loader />}
        </Button>
    );
}
